import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { api, setToken } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("richard.blake4hire@yahoo.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.token);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-transparent border border-white/20 text-white placeholder-white/35 px-4 py-3.5 text-sm focus:outline-none focus:border-gold transition-colors";

  return (
    <div className="min-h-screen bg-ink text-white font-body flex items-center justify-center px-5">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <span className="bg-white rounded-md p-1.5">
            <img src="/logo-white.png" alt="B3 Contracting LLC" className="h-16 w-auto object-contain" />
          </span>
        </div>
        <div className="bg-surface border border-line p-8">
          <div className="flex items-center gap-2 text-gold mb-6">
            <Lock size={18} />
            <h1 className="font-heading font-semibold text-xl tracking-tight text-white">Admin Sign In</h1>
          </div>
          <form onSubmit={onSubmit} className="space-y-4">
            <input
              data-testid="login-email"
              type="email"
              className={inputCls}
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              data-testid="login-password"
              type="password"
              className={inputCls}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              data-testid="login-submit"
              type="submit"
              disabled={loading}
              className="w-full bg-gold text-ink font-semibold px-8 py-4 hover:bg-gold-hover transition-colors disabled:opacity-60"
            >
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>
        </div>
        <a href="/" className="mt-6 block text-center text-sm text-white/50 hover:text-gold transition-colors">
          ← Back to website
        </a>
      </div>
    </div>
  );
}
